import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';
import CancellationPolicy, { ICancellationPolicy } from './cancellationPolicy';
import DaysOfWeek, { IDaysOfWeek } from './days-of-week';
import GroupedServiceOptions, { IGroupedServiceOptions } from './grouped-options';
import PriceMinMax, { IMinMax } from './price-min-max';

export interface IPeriod {
  startDate: Date;
  endDate: Date;
  daysOfWeek?: IDaysOfWeek;
  price?: IMinMax;
  priceCapacity?: number;
  minCapacity?: number;
  maxCapacity?: number;
  cancellable: boolean;
  cancellationPolicies: ICancellationPolicy[];
  groupedOptions: IGroupedServiceOptions[];
}

export interface IPeriodDocument extends mongoose.Document, IPeriod {
  _id: ObjectID;
}

const period = new Schema({
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },

  daysOfWeek: {
    type: DaysOfWeek,
    required: false,
  },
  price: {
    type: PriceMinMax,
    required: false,
  },
  priceCapacity: {
    type: Number,
    required: false,
    min: 0,
  },
  minCapacity: {
    type: Number,
    required: false,
    min: 1,
  },
  maxCapacity: {
    type: Number,
    required: false,
    min: 1,
  },
  cancellable: {
    type: Boolean,
    default: false,
    required: false,
  },
  cancellationPolicies: {
    type: [CancellationPolicy],
    required: false,
  },
  groupedOptions: {
    type: [GroupedServiceOptions],
    default: [],
  },
});

export default period;
